import { createSlice } from '@reduxjs/toolkit'

export const permissionsSlice = createSlice({
  name: 'permissions',
  initialState: {
    allowedCards: [],
    loaded: false,
  },
  reducers: {
    setAllowedCards: (state, action) => {
      state.allowedCards = action.payload.allowed_cards
      state.loaded = true
    },
  },
})

export const { setAllowedCards } = permissionsSlice.actions

export const selectHasCardPermission = (state, cardKey) =>
  state.permissions.allowedCards.includes(cardKey)

export default permissionsSlice.reducer
